import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostFarmRequirement from '.';

interface IPostFarmRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostFarmRequirement = ({onSuccess}: IPostFarmRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IFarmRequirementPayload) => {
      return PostFarmRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostFarmRequirement};
